export const LANGUAGE_INIT = '@moka-i18n/LANGUAGE_INIT';
export const LANGUAGE_INIT_SUCCESS = '@moka-i18n/LANGUAGE_INIT_SUCCESS';
export const LANGUAGE_INIT_FAILURE = '@moka-i18n/LANGUAGE_INIT_FAILURE';
export const LANGUAGE_UPDATE = '@moka-i18n/LANGUAGE_UPDATE';
